import { setAuthToken, setLocationHeader } from '../api/clients';
import { useLocationStore } from '../location/locationStore';
import { ascendIdForLocationUuid } from '../location/resolveLocationHeaderValue';
import { parseAccessTokenPayload } from './parseAccessToken';
import { getStoredToken } from './tokenStorage';

/** Attach stored access token + location header to account and main API clients. */
export function wireSessionToApi(): void {
  const token = getStoredToken();
  if (token) {
    setAuthToken(token);
  }

  const locationUuid = useLocationStore.getState().getSelectedLocationUuid();
  if (!locationUuid || !token) {
    return;
  }

  const payload = parseAccessTokenPayload(token);
  if (!payload) {
    return;
  }

  const ascendId = ascendIdForLocationUuid(locationUuid, payload.locations, payload.access);
  if (ascendId) {
    setLocationHeader(ascendId);
  }
}
